module.exports = __webpack_public_path__ + "static/media/ic-school.84de95fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-school.svg
// module id = 441
// module chunks = 0